import { getImage } from "../../../utils/getImage";
import SvgSad from "./SvgSad";
import SvgHappy from "./SvgHappy";
import SvgAngry from "./SvgAngry";
import SvgBored from "./SvgBored";
import SvgHappy_2 from "./SvgHappy_2";

export const ImageResponses = ({
  quality,
  responses,
  PreguntaId,
  enableSendButton,
  encuestaNueva,
}) => {
  if (true) {
    return (
      <>
        <div className={quality}>
          {responses.map((res) => {
            if (res.RespuestaQuality === quality) {
              if (!getImage(9, encuestaNueva).includes(".svg")) {
                return (
                  <div key={res.RespuestaId} className="response">
                    <div className="radio-item">
                      <input
                        onClick={enableSendButton}
                        id={res.RespuestaId}
                        className="inputs"
                        type={"radio"}
                        name={PreguntaId}
                        subpreguntaid={res.SubPreguntaId}
                      />
                      <label htmlFor={res.RespuestaId}>
                        <img
                          src={
                            res.RespuestaQuality === "bad"
                              ? getImage(9, encuestaNueva)
                              : res.RespuestaQuality === "regular"
                              ? getImage(10, encuestaNueva)
                              : res.RespuestaQuality === "good"
                              ? getImage(11, encuestaNueva)
                              : res.RespuestaQuality === "semibad"
                              ? getImage(13, encuestaNueva)
                              : getImage(14, encuestaNueva)
                          }
                          className="image-response"
                          alt="imagen"
                        />
                      </label>
                    </div>

                    <span>{res.RespuestaTexto}</span>
                  </div>
                );
              } else {
                return (
                  <div key={res.RespuestaId} className="response">
                    <div className="radio-item">
                      <input
                        onClick={enableSendButton}
                        id={res.RespuestaId}
                        className="inputs"
                        type={"radio"}
                        name={PreguntaId}
                        subpreguntaid={res.SubPreguntaId}
                      />
                      <label htmlFor={res.RespuestaId}>
                        {res.RespuestaQuality === "bad" ? (
                          <SvgAngry />
                        ) : res.RespuestaQuality === "regular" ? (
                          <SvgBored />
                        ) : res.RespuestaQuality === "good" ? (
                          <SvgHappy />
                        ) : res.RespuestaQuality === "semibad" ? (
                          <SvgSad />
                        ) : (
                          <SvgHappy_2 />
                        )}
                      </label>
                    </div>

                    <span>{res.RespuestaTexto}</span>
                  </div>
                );
              }
            }
          })}
        </div>
      </>
    );
  } else {
    return null;
  }
};
